// Single source of truth for Abraham Oladotun Foundation contact details.
// Update this file only - Contact.js, Footer.js and structuredData.js all read from it.

export const ORG_EMAIL = 'info@aofnfp.org';
export const ORG_SITE = 'https://aofnfp.org';

export const OFFICE_HOURS_NG = 'Mon - Fri: 9:00 AM - 5:00 PM (WAT)';
export const OFFICE_HOURS_US = 'Mon - Fri: 9:00 AM - 5:00 PM (CT)';

export const OFFICES = [
  {
    id: 'ng',
    country: 'Nigeria',
    countryCode: 'NG',
    flag: 'NG',
    label: 'Nigeria Office',
    entity: 'Abraham Oladotun Foundation',
    registration: 'Registered with the Corporate Affairs Commission (Incorporated Trustees)',
    // TODO(address): replace with the exact street address supplied by the Foundation.
    addressLines: ['Nigeria'],
    phone: '+234 808 871 3372',
    phoneHref: '+2348088713372',
    email: ORG_EMAIL,
    hours: OFFICE_HOURS_NG,
    note: 'Programme delivery, school placements and family support.'
  },
  {
    id: 'us',
    country: 'United States',
    countryCode: 'US',
    flag: 'US',
    label: 'United States Office',
    entity: 'Abraham Oladotun Foundation NFP',
    registration: '501(c)(3) non-profit registered in Texas',
    // TODO(address): replace once the PO Box / registered office is confirmed.
    addressLines: ['Texas, United States'],
    phone: null,
    phoneHref: null,
    email: ORG_EMAIL,
    hours: OFFICE_HOURS_US,
    note: 'Governance, US donations and tax-deductible giving.'
  }
];

// Region detection.
// Timezone-based: no network call, no CORS, no IP lookup, resolves before first paint,
// and degrades to the default order if unavailable. Contact details are never hidden -
// location only decides which office is shown first.
export const isAfricaVisitor = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    return tz.startsWith('Africa/');
  } catch (e) {
    return false;
  }
};

// Returns both offices, always. Africa-based visitors see Nigeria first.
export const getOrderedOffices = () => {
  const africa = isAfricaVisitor();
  return africa
    ? OFFICES.filter((o) => o.id === 'ng').concat(OFFICES.filter((o) => o.id !== 'ng'))
    : OFFICES.filter((o) => o.id === 'us').concat(OFFICES.filter((o) => o.id !== 'us'));
};

export const getPrimaryOffice = () => getOrderedOffices()[0];
